import React from 'react';
import { Shield, Award, Truck, Clock } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const GuaranteeSection = ({ guaranteeInfo }) => {
  const features = [
    {
      icon: Shield,
      title: "Warranty Protection",
      description: guaranteeInfo.warranty
    },
    {
      icon: Award,
      title: "Genuine Parts",
      description: guaranteeInfo.genuineParts
    },
    {
      icon: Truck,
      title: "Insured Service",
      description: guaranteeInfo.insurance
    },
    {
      icon: Clock,
      title: "Certified Technicians",
      description: guaranteeInfo.certifiedTechs
    }
  ];

  return (
    <div className="py-16 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Our Guarantee
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            We stand behind our work with comprehensive warranty coverage and certified service standards.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <Card key={index} className="border-0 shadow-sm hover:shadow-md transition-shadow duration-200">
                <CardContent className="p-6 text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-blue-50">
                    <IconComponent className="w-8 h-8 text-blue-600" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-12 p-6 bg-white rounded-lg shadow-sm">
          <h3 className="text-xl font-semibold text-gray-900 mb-3">
            About Our Service
          </h3>
          <p className="text-gray-600 mb-4">
            We guarantee our service, including replacement parts, for 15 days from the date of repair. 
            This is in addition to your rights provided by consumer law.
          </p>
          <p className="text-gray-600">
            All replacement parts we provide are tested and certified to meet strict quality standards. 
            Our fully insured pickup and delivery service ensures your device is protected throughout the repair process.
          </p>
        </div>
      </div>
    </div>
  );
};

export default GuaranteeSection;